import React from 'react'

function SvgDashboard() {
  return (
    // <svg
    //   aria-hidden='true'
    //   focusable='false'
    //   data-prefix='fas'
    //   data-icon='columns'
    //   className='svg-inline--fa fa-columns fa-2x fa-w-16'
    //   role='img'
    //   xmlns='http://www.w3.org/2000/svg'
    //   viewBox='0 0 512 512'
    // >
    //   <path
    //     className='fa-dashboard'
    //     fill='currentColor'
    //     d='M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z'
    //   ></path>
    // </svg>
    <svg
      aria-hidden='true'
      focusable='false'
      data-prefix='fas'
      data-icon='chart-bar'
      className='svg-inline--fa fa-chart-bar fa-w-16'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
    >
      <path
        className='fa-dashboard'
        fill='currentColor'
        d='M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z'
      ></path>
    </svg>
  )
}

export default SvgDashboard
